export default __webpack_public_path__ + "locales/bg/SingleSignOn.json?hash=07032d339dc83a3a5f690fc8772d0118";